define('checkPreInit/checkHttps',['common/config', './loadingErrors'], function(config, errors) {
    'use strict';
    return {
        checkHttps: checkHttps
    };

    function checkHttps(data, next) {
        next(config.canProcede ? null : errors.NOT_HTTPS);
    }
});
